<template>
    <card-list>
        <subheader-list-item icon="fa-user" title="Information" />

        <container-list-item padded>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="First Name" label-position="inside">
                        <b-input v-model="user.first_name" required></b-input>
                    </b-field>
                </div>
                <div class="column is-6">
                    <b-field label="Last Name" label-position="inside">
                        <b-input v-model="user.last_name"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Username" label-position="inside">
                        <b-input type="email" v-model="user.username" required></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Password (Set to Change)" label-position="inside">
                        <b-input v-model="user.password"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Access Level" label-position="inside">
                        <b-select v-model="user.content_provider_id" expanded>
                            <option :value="null">All Organization & Content Providers</option>
                            <option v-for="provider in org.content_providers" :key="provider.id" :value="provider.id">Limited to {{ provider.title }}</option>
                        </b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch v-model="user.is_approval_committee" :true-value="1" :false-value="0">On Approval Committee</b-switch>
                        <template #message>Portal user will have access to review new applications that require approval.</template>
                    </b-field>
                </div>
            </div>

        </container-list-item>

        <template v-if="currentUser.isSuper">
            <subheader-list-item icon="fa-align-left" title="Advanced" />
            <container-list-item padded>
                <div class="columns">
                    <div class="column">
                        <b-field label="Permission Role" label-position="inside">
                            <b-input v-model="user.role"></b-input>
                        </b-field>
                    </div>
                </div>
            </container-list-item>
        </template>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";
    import {mapGetters} from "vuex";

    export default {
        name: 'OrgUserForm',
        props: {
            user: {
                type: Object,
                required: true
            },
            org: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function () {
            return {};
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {},
        mounted: function () {

        }
    };
</script>

<style lang="scss">
    .select.is-empty select {
        color: #363636 !important;
    }
</style>
